import { createAction } from "redux-actions";

export const updateSectionGuardianMessageSettingReceived = createAction(
  "UPDATE_SECTION_GUARDIAN_MESSAGE_SETTING_RECEIVED",
);
export const updateSectionGuardianMessageSettingError = createAction(
  "UPDATE_SECTION_GUARDIAN_MESSAGE_SETTING_ERROR",
);
